<template>
  <div v-bind="$attrs" v-on="$listeners" class="elevation-1 paper">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PagePaper'
}
</script>

<style lang="scss" scoped>
 .paper {
    margin: 12px 0;
    padding: 40px 50px 50px 57px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 26px;
  }
</style>
